/* eslint-disable @typescript-eslint/no-explicit-any */
import { get } from 'lodash';
import {
  Control,
  FieldErrors,
  FieldValues,
  UseFormRegister,
  UseFormReturn,
} from 'react-hook-form';
import { SMap } from './types';

export function muiForm<T extends FieldValues>(
  methods: UseFormReturn<T>,
): UseFormReturn<T> {
  const {
    register: originalRegister,
    formState: { errors },
  } = methods;

  const register: UseFormRegister<T> = (path, options) => {
    const props = originalRegister(path, options);

    return {
      ...props,
      error: Boolean(get(errors, path)),
      helpertext: get(errors, path)?.message,
    };
  };

  return {
    ...methods,
    register,
  };
}

export type FormControls<T extends SMap<any>> = {
  control: Control<T, any, T>;
  errors: FieldErrors<T>;
  setValue: UseFormReturn<T>['setValue'];
};

export const toFormControls = <T extends SMap<any>>(
  form: UseFormReturn<T>,
): FormControls<T> => ({
  control: form.control,
  errors: form.formState['errors'],
  setValue: form.setValue,
});
